module.exports = __webpack_public_path__ + "static/favonius-warbow-a2ab8c82465b649ff56f849ed8aab060.png";